import { render, staticRenderFns } from "./commonBar.vue?vue&type=template&id=0ff4a240&scoped=true"
import script from "./commonBar.vue?vue&type=script&lang=js"
export * from "./commonBar.vue?vue&type=script&lang=js"
import style0 from "./commonBar.vue?vue&type=style&index=0&id=0ff4a240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff4a240",
  null
  
)

export default component.exports